import { createEffect, createEvent, createStore, sample } from 'effector';
import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { EsignDocs } from './types';

const initialEsignDocsState: EsignDocs = {
  docs: [],
};

export const $esignDocs = createStore<EsignDocs>(initialEsignDocsState);

export function getDocByAttachmentIdParams(attachmentId: string) {
  return {
    keys: [attachmentId],
    store: $esignDocs,
    fn: (state: EsignDocs, [keyAttachmentId]: string[]) =>
      state.docs.find((doc) => doc.attachmentId === keyAttachmentId) ?? null,
  };
}

export const updateEsignDocsEvent = createEvent<{ portalId: string }>();
const getDocumentsFx = createEffect(async (portalId: string) => {
  const { data } = await axiosClient.post<{ docs: EsignDocs['docs'] }>(
    `${generalEnv.nextApiPath}/esign/portal/documents`,
    { portalId }
  );
  return data;
});
$esignDocs.on(getDocumentsFx.doneData, (esignDocs, data) => ({
  ...esignDocs,
  docs: data.docs,
}));
sample({
  source: $esignDocs,
  clock: updateEsignDocsEvent,
  fn: (_, { portalId }) => portalId,
  target: getDocumentsFx,
});
